import { BaseEvent } from './base-event';
import { EventName } from '../event-name';

export interface SessionStarted {
  ContextId?: string;
  UserAgent?: string;
  DeviceTimezone: string;
  ProductId: string;
  ReferringUrl?: string;
  RefCode?: string;
  RefSource?: string;
  MemberId?: string;
}

export class SessionStartedEvent extends BaseEvent {
  override Data: SessionStarted = null;

  // Event Configuration
  override Name: EventName = 'SessionStarted';
  override ContextPropertyName = 'SessionStartedId';

  constructor(event: SessionStarted = null) {
    super();
    this.Data = event;
  }
}
